import { render, staticRenderFns } from "./PrivacyAndAgreement.vue?vue&type=template&id=e1ea632a&"
import script from "./PrivacyAndAgreement.vue?vue&type=script&lang=js&"
export * from "./PrivacyAndAgreement.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyAndAgreement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports